import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";
import {translate} from "react-i18nify";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";
import * as componentTypes from "../constants/componentTypes";

const favoritesTabInit = (action$) =>
    action$.pipe(
        ofType(actionTypes.FAVORITES_TAB_INIT),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.COLORANT_PANEL_INIT,
                    payload: {
                        tabId: payload.tabId,
                        type: componentTypes.FAVORITES_TAB
                    }
                }
            ];
        })
    );

const selectFavorite = (action$) =>
    action$.pipe(
        ofType(actionTypes.SELECT_FROM_FAVORITES),
        switchMap(({payload}) => {
            if (payload.color === null || payload.product === null || payload.fandeck === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_CALCULATED_FORMULA,
                        params: {
                            productId: payload.product.id,
                            fandeckId: payload.fandeck.id,
                            colorId: payload.color.id,
                            isLocal: payload.color.local
                        }
                    },
                    method: handlers.GET_CALCULATED_FORMULA,
                    tabId: payload.tabId
                }
            ];
        })
    );

const removeFromFavorites = (action$) =>
    action$.pipe(
        ofType(actionTypes.FAV_TAB_REMOVE_FROM_FAVORITES),
        switchMap(({payload}) => {
            if (payload.id === null) {
                return [];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_REMOVE_FAVORITE_FORMULA,
                        params: {
                            id: payload.id
                        }
                    },
                    method: handlers.REMOVE_FAVORITE_FORMULA,
                    tabId: payload.tabId
                }
            ];
        })
    );

const addFavoritesFolder = (action$) =>
    action$.pipe(
        ofType(actionTypes.ADD_FAVORITES_FOLDER),
        switchMap(({payload}) => {
            let parentId = payload.parentId === -1 ? null : payload.parentId;
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_ADD_FAVORITE_FOLDER,
                        params: {
                            parentId: parentId,
                            name: translate("favoritesTab.newFolder")
                        }
                    },
                    method: handlers.ADD_FAVORITE_FOLDER,
                    tabId: payload.tabId
                }
            ];
        })
    );

const editFavoritesFolder = (action$) =>
    action$.pipe(
        ofType(actionTypes.EDIT_FAVORITES_FOLDER),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_EDIT_FAVORITE_FOLDER,
                        params: {
                            id: payload.folderId,
                            name: payload.newName
                        }
                    },
                    method: handlers.EDIT_FAVORITE_FOLDER,
                    tabId: payload.tabId
                }
            ];
        })
    );

const editFavorites = (action$) =>
    action$.pipe(
        ofType(actionTypes.EDIT_FAVORITES),
        switchMap(({payload}) => {
            let folderId = [-1, 0].includes(payload.folderId) ? null : payload.folderId;
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_MOVE_FAVORITE_FORMULA,
                        params: {
                            id: payload.favoriteId,
                            folderId: folderId
                        }
                    },
                    method: handlers.MOVE_FAVORITE_FORMULA,
                    tabId: payload.tabId
                }
            ];
        })
    );

const deleteFavoritesFolder = (action$) =>
    action$.pipe(
        ofType(actionTypes.DELETE_FAVORITES_FOLDER),
        switchMap(({payload}) => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_REMOVE_FAVORITE_FOLDER,
                        params: {
                            id: payload.folderId,
                            removeContent: payload.removeContent
                        }
                    },
                    method: handlers.REMOVE_FAVORITE_FOLDER,
                    tabId: payload.tabId
                }
            ];
        })
    );

export default [
    favoritesTabInit,
    selectFavorite,
    removeFromFavorites,
    addFavoritesFolder,
    editFavoritesFolder,
    editFavorites,
    deleteFavoritesFolder
];
